/**
 * 予算・計画・実績表画面　入力VOクラス
 */
export class KYMW1307InputModel {

  /** 表示モード */
  public displayMode: string = null;
  /** 受注コード */
  public orderCode: string = null;
  /** 媒体区分 */
  public mediumType: string = null;
  /** 売場コード */
  public sellAreaCode: string = null;
  /** 注文コード割当コード */
  public orderNumQuotaCode: string = null;
  /** 生協コード */
  public coopCode: string = null;
  /** 部門コード */
  public classCode: string = null;
  /** 中分類コード */
  public middleClassCode: string = null;
  /** 小分類コード */
  public smallClassCode: string = null;
  /** ページ番号 */
  public pageNum: string = null;
  /** バイヤーコード */
  public buyerCode: string = null;
  /** 未掲載フラグ */
  public nonCarryFlag: string = null;
  /** 発注先コード */
  public orderClientCode: string = null;
  /** 発注先名称 */
  public orderClientKanji: string = null;
  /** 支払先コード */
  public payeeClientCode: string = null;
  /** 支払先名称 */
  public payeeClientKanji: string = null;

}
